import { useMutation } from "@tanstack/react-query";
import { updateUser } from "../../../api/users/updateUser";

export const useUpdateUser = () => {

  return useMutation({
    mutationKey: ["updateUser"],
    mutationFn: updateUser
  });
};
